import { selectLoggingOut } from '../../store/auth/selectors';
import { useDispatch, useSelector } from '../../store/store';
import { setLogOutModal } from '../../store/auth/slice';
import { LogOutSquareIcon } from '../../assets/icons';
import { logOutThunk } from '../../store/auth/thunks';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function LogOut() {
    const dispatch = useDispatch();
    const isLoading = useSelector(selectLoggingOut);

    const confirmLogOut = () => {
        dispatch(logOutThunk())
    };

    return (
        <Modal
            size='sm'
            title='Sign out'
            icon={<LogOutSquareIcon />}
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setLogOutModal(false))}
            actions='both'
            dismissButton={{
                text: 'Cancel',
                type: 'Outline-Dark',
                onClick: () => dispatch(setLogOutModal(false)),
            }}
            confirmButton={{
                text: 'Sign out',
                type: 'Error',
                loading: isLoading,
                onClick: confirmLogOut,
            }}
        >
            <span className={styles.text}>Are you sure you want to sign out ?</span>
        </Modal>
    )
}
